// extracted by mini-css-extract-plugin
export var container = "_sg-0";
export var dotAnimation = "_sg-2";
export var dotsLoading = "_sg-1";